import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';


const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-col footer-about">
              <div className="footer-logo">
                <img src="/logo & badge images/logo-white.png" alt="Shikhar Dhara" />
                <h3>Shikhar Dhara</h3>
              </div>
              <p>
                Premium packaged drinking water and litchi fruit juice manufacturer. 
                Committed to purity, quality, and customer satisfaction since our inception.
              </p>
              <div className="footer-certifications">
                <img src="logo & badge images/fssai-logo.png" alt="FSSAI Certified" />
                <img src="/logo & badge images/bis-logo.png" alt="BIS Certified" />
                <img src="/logo & badge images/iso-logo.png" alt="ISO Certified" />
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/products">Our Products</Link></li>
                <li><Link to="/manufacturing">Manufacturing</Link></li>
                <li><Link to="/distributor">Become Distributor</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
              </ul>
            </div>

            {/* Products */}
            <div className="footer-col">
              <h4>Our Products</h4>
              <ul>
                <li><Link to="/products">Packaged Drinking Water</Link></li>
                <li><Link to="/products">250ml / 500ml Bottles</Link></li>
                <li><Link to="/products">1 Litre / 20 Litre Jars</Link></li>
                <li><Link to="/products">Litchi Fruit Juice</Link></li>
                <li><Link to="/products">Fruit Juice Packs</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-col">
              <h4>Contact Us</h4>
              <ul className="contact-list">
                <li>
                  <span className="icon"><FaMapMarkerAlt /></span>
                  <span>
                    UPSIDC Industrial Area, Building No. D-49, Road No. 1, 
                    Parsakhera Industrial Area, Bareilly, Uttar Pradesh – 243502
                  </span>
                </li>
                <li>
                  <span className="icon"><FaPhoneAlt /></span>
                  <div>
                    <a href="tel:+918077894559">+91 8077894559</a>
                    <br />
                    <a href="tel:+917983864997">+91 79838 64997</a>
                  </div>
                </li>
                <li>
                  <span className="icon"><FaEnvelope /></span>
                  <a href="mailto:info@shikhardhara.com">info@shikhardhara.com</a>
                </li>
                <li>
                  <span className="icon"><FaWhatsapp /></span>
                  <div style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                    <a 
                      href="https://wa.me/918077894559?text=Hello, I'm interested in Shikhar Dhara products"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      WhatsApp: +91 8077894559
                    </a>
                    <a 
                      href="https://wa.me/917983864997?text=Hello, I'm interested in Shikhar Dhara products"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      WhatsApp: +91 79838 64997
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Shikhar Dhara. All Rights Reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
